import type { SerializedEditorState } from 'lexical';
import { z } from 'zod';

export const richTextSchema = z.custom<SerializedEditorState>();
export type RichText = z.infer<typeof richTextSchema>;
